import styled from "styled-components";
import { theme } from "../../../styles/theme";

export const ContainerTable = styled.div`
  width: 100%;
  max-width: ${({ $maxWidth }) => $maxWidth || "100%"};
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  background: #ffffff;
  overflow: hidden;
  overflow-x: auto;

  ::-webkit-scrollbar {
    width: 2px;
    height: 2px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 8px;
  }
`;

export const DesktopCard = styled.div`
  display: block;

  @media (max-width: 767px) {
    display: none;
  }
`;

export const MobileCard = styled.div`
  display: none;

  @media (max-width: 767px) {
    display: block;
  }
`;

export const ContainerTableRow = styled.div`
  width: ${({ $width }) => $width || "100%"};
  padding: 12px;
  border-bottom: ${({ $lastChild }) => ($lastChild ? "0" : "1px solid #eceff3")};
  background-color: ${({ $disabled }) => ($disabled ? "#f8f9fb" : "#ffffff")};
  border: 2px solid ${theme.colors.gray.Cinza_12};
  border-radius: 8px;
  margin-bottom: 1rem;

  cursor: ${({ $clickable }) => ($clickable ? "pointer" : "not-allowed")};

  @media (max-width: 767px) {
    width: 100%;
  }
`;

export const HeaderRow = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
`;

// Centralizado de verdade (independe da largura da data/badge nas laterais) - space-between
// só divide o espaço sobrando, não centraliza o item do meio.
export const AttentionIconWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const DateText = styled.span`
  color: ${({ $disabled }) => ($disabled ? "#b7bdc8" : "#2d3440")};
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 1px;
`;

export const StatusBadge = styled.div`
  padding: 6px 10px;
  border-radius: 999px;
  background: ${({ $variant }) =>
    $variant === "success"
      ? "#e7f7ed"
      : $variant === "error"
        ? "#f9e9e9"
        : $variant === "waiting"
          ? "#f5efe5"
          : "#eef1f5"};
  color: ${({ $variant }) =>
    $variant === "success"
      ? "#2fbb69"
      : $variant === "error"
        ? "#ff5252"
        : $variant === "waiting"
          ? "#b7791f"
          : "#6b7280"};
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 1px;
  text-transform: uppercase;
  white-space: nowrap;
`;

export const TopRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
`;

export const ProductColumn = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

export const ProductText = styled.div`
  color: ${({ $disabled }) => ($disabled ? "#b7bdc8" : "#1f2736")};
  font-size: 16px;
  line-height: 24px;
  font-weight: 900;
  word-break: break-word;
`;

export const QtyColumn = styled.div`
  width: 76px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-top: 2px;
`;

export const QtyBadge = styled.div`
  border-radius: 999px;
  background: #eef1f5;
  padding: 5px 8px;
`;

export const QtyText = styled.div`
  color: #2d3440;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 1px;
  text-align: center;
  text-transform: uppercase;
`;

export const MetaSection = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const MetaRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
`;

export const MetaRowSplit = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-width: 0;
`;

export const BlueBadge = styled.div`
  max-width: 100%;
  padding: 5px 10px;
  border-radius: 999px;
  background: #589bff;
`;

export const BlueBadgeText = styled.div`
  color: #ffffff;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 1px;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const LocalBadge = styled.div`
  max-width: 76%;
  min-width: 0;
  padding: 5px 10px;
  border-radius: 999px;
  background: #eef1f5;
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 1;
`;

export const LocalBadgeText = styled.div`
  color: #589bff;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 1px;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const DarkBadge = styled.div`
  margin-left: auto;
  padding: 5px 10px;
  border-radius: 999px;
  background: #1f2736;
  flex-shrink: 0;
`;

export const DarkBadgeText = styled.div`
  color: #ffffff;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 1px;
  text-transform: uppercase;
  white-space: nowrap;
`;

export const ExtraMetaRow = styled.div`
  margin-top: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const ExtraMetaLeft = styled.div`
  flex: 1.35;
  min-width: 0;
  display: flex;
  justify-content: flex-start;
`;

export const ExtraMetaCenter = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  justify-content: center;
  padding: 0 6px;
`;

export const ExtraMetaRight = styled.div`
  flex: ${({ $solo }) => ($solo ? '1' : '0.75')};
  min-width: 0;
  display: flex;
  justify-content: ${({ $solo }) => ($solo ? 'flex-start' : 'flex-end')};
`;

export const TechBadge = styled.div`
  max-width: 100%;
  min-width: 0;
  padding: 6px 10px;
  border-radius: 999px;
  background: #f5f7fa;
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const TechBadgeText = styled.div`
  color: ${({ $disabled }) => ($disabled ? "#b7bdc8" : "#1f2736")};
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 1px;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const InlineMetaText = styled.div`
  color: ${({ $disabled }) => ($disabled ? "#b7bdc8" : "#1f2736")};
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 1px;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const OrderInlineText = styled(InlineMetaText)`
  flex-shrink: 0;
  text-align: right;
`;

export const LegacyCard = styled.div`
  width: 100%;
  height: auto;
  gap: 9px;
  display: flex;
  justify-content: space-between;
`;

export const LegacyTableColumnStart = styled.div`
  width: auto;
  height: auto;
  gap: 8px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  min-width: 0;
  flex: 1;
`;

export const LegacyTableColumnEnd = styled.div`
  width: auto;
  height: auto;
  gap: 8px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-between;
  flex-shrink: 0;
`;

export const LegacyTableColumnContain = styled.div`
  width: 100%;
  height: auto;
  gap: 8px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 0;
`;

export const LegacyOrderRow = styled.div`
  width: 100%;
  height: auto;
  display: flex;
`;

export const LegacyOrderCell = styled.div`
  width: auto;
  min-width: ${({ $minWidth }) => $minWidth || 'auto'};
  padding-right: ${({ $paddingRight }) => $paddingRight || '13px'};
  display: flex;
  align-items: center;
`;

export const LegacyProductCell = styled.div`
  min-width: 177px;
  max-width: ${({ $maxWidth }) => $maxWidth || '100%'};
  width: auto;
  min-width: 0;
  overflow-x: auto;
  display: flex;
  align-items: flex-start;
  justify-content: ${({ $justifyContent }) => $justifyContent || 'flex-start'};

  > h6,
  > p {
    white-space: nowrap;
  }

  ::-webkit-scrollbar {
    width: 0;
    height: 1px;
  }
`;

export const LegacyMetaRow = styled.div`
  width: auto;
  height: auto;
  gap: 8px;
  display: flex;
  align-items: center;

  > p {
    white-space: nowrap;
  }

  > p:nth-child(1) {
    height: 24px;
    margin-left: 7.6rem;
    margin-right: 0.5rem;
    display: flex;
    align-items: center;
  }
`;

export const LegacyStatusRow = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-between;
`;
